<template>
    <v-card   style="width:100%; z-index:1; border-radius:20px!important" flat  >  

     <GmapMap
           ref="googleMap"
           :center="centerToUse"
           :zoom="zoom"
           map-type-id="roadmap"
           style="width: 100%;"
           :style="`height: 250px`"
           :options="{
               zoomControl: false,
               mapTypeControl: false,
               scaleControl: false,
               streetViewControl: false,
               rotateControl: false,
               fullscreenControl: false,
               disableDefaultUi: true,
               isFractionalZoomEnabled: true,
               gestureHandling: 'greedy',
               styles: mapStyle
           }"
       >
       
           <template v-slot:visible v-if="isMapInitialized == true" >
              
              <!-- User Marker -->
              <GmapMarker                
                :icon="userMarker"                 
                :position="userPosition"
                :clickable="false"
                :draggable="false"                 
              />
              
              <!-- Driver Marker -->
              <GmapMarker      
                v-if="centerToUse.lat > 0 && centerToUse.lng > 0 && showDefaultMap == false"          
                :icon="driverMarker"                 
                :position="{ lat: parseFloat(centerToUse.lat), lng: parseFloat(centerToUse.lng) }"
                :key="centerToUse.lat"
                :clickable="false"
                :draggable="false"                 
              />

              <!-- Store Marker -->
              <GmapMarker                
                :icon="storeMarker"                 
                :position="{ lat: parseFloat(storeMarkerObject.lat), lng: parseFloat(storeMarkerObject.lng) }"
                :clickable="false"
                :draggable="false"                 
              />

              <!-- map polyline -->
              <gmap-polyline 
                v-if="polyline" 
                :path="polyline" 
                :strokeWeight="3" 
              />
           </template>
       </GmapMap>


    </v-card>
</template>

<script lang="js">
import Vue from 'vue'
import GmapVue, { getGoogleMapsAPI } from 'gmap-vue';
import  CustomGoogleAutocomplete  from 'vue-custom-google-autocomplete'
import {  mapGetters, mapState } from "vuex";
import GooglePlacesAutocomplete from "@/components/Location/GooglePlacesAutocomplete.vue"
import GoogleMapStyle from "./GoogleMapStyle"

Vue.use(CustomGoogleAutocomplete)
Vue.use(GmapVue, {
 // The API key comes from partnerSettings.googleMapsApiKey and isn't known yet at this
 // point (module load time, before partner settings resolve). dynamicLoad: true tells
 // gmap-vue to only wire up window.GoogleMapsCallback and wait; the actual script tag is
 // injected later by loadGoogleMapsApi() (see App.vue) once the real key is available.
 dynamicLoad: true,

 // [OPTIONAL] If you intend to programmatically custom event listener code
 // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
 // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
 // you might need to turn this on.
 autoBindAllEvents: false,

 // [OPTIONAL] If you want to manually install components, e.g.
 // import {GmapMarker} from 'gmap-vue/src/components/marker'
 // Vue.component('GmapMarker', GmapMarker)
 // then set installComponents to 'false'.
 // If you want to automatically install all the components this property must be set to 'true':
 installComponents: true,
})


export default Vue.extend({
   components:{ "auto-complete-location-search": GooglePlacesAutocomplete},
   
   props: ["center", "polyline", "storeMarkerObject", "userPosition", "showDefaultMap"],

   data: () => ({
       zoom: 16,
       isMapInitialized: false,
       mapStyle: GoogleMapStyle,
   }),

   computed: {

      ...mapState("partner", ["partnerSettings"]),
      ...mapState("store", ["selectedStoreDetails"]),
       
       google: getGoogleMapsAPI,

       userMarker() {
         var image = {
           url: this.partnerSettings.userMapMarkerImageUrl,
           size: new google.maps.Size(71, 71),
           origin: new google.maps.Point(0, 0),
           anchor: new google.maps.Point(17, 34),
           scaledSize: new google.maps.Size(35, 35)
         };

         return image
       },
       
       driverMarker() {
         var image = {
           url: this.partnerSettings.driverMapMarkerURL,
           size: new google.maps.Size(71, 71),
           origin: new google.maps.Point(0, 0),
           anchor: new google.maps.Point(17, 34),
           scaledSize: new google.maps.Size(35, 35)
         };

         return image
       },

       storeMarker() {
         var image = {
           url: this.storeMarkerObject.marker,
           size: new google.maps.Size(71, 71),
           origin: new google.maps.Point(0, 0),
           anchor: new google.maps.Point(17, 34),
           scaledSize: new google.maps.Size(35, 35)
         };

         return image
       },

       centerToUse: {
           get(){
               return this.center;
           },

           set(value) {
               this.$emit("changed", value);
           }
       },
   },

   watch: {
    centerToUse() {
      if(this.showDefaultMap == false) {
        this.$forceUpdate();
      }
    }
   },
   
   model: {
       prop: "center",
       event: "changed",
   },

  async mounted() {
      await this.$gmapApiPromiseLazy().then(() => {
        this.isMapInitialized = !!window.google;
    });
  }
  
})
</script>